<template>
  <div>
    <div class="banner">
      <Head></Head>
      <div class="topT">
        <div class="leftC">
          <div class="bTitle">码客通SCRM智能营销管理系统</div>
          <div class="sTitle">助力企业数字化运营，打造企业私域数字营销闭环</div>
          <div class="tyBtn">立即体验</div>
        </div>
        <div class="rightImg"></div>
      </div>
    </div>
    <div class="bottleneck">
      <div class="title">企业增长难题 私域增长瓶颈</div>
      <div class="content">
        <div v-for="(item, index) in bottleneckList" :key="index">
          <img :src="item.img" alt="">
          <div class="it">{{item.title}}</div>
          <div class="ic">{{item.content}}</div>
        </div>
      </div>
    </div>
    <div class="flowPool">
      <div class="title">多渠道获客触达 快速构建私域流量池</div>
      <div class="content">
        <div class="leftinfo">
          <div class="ft">移动办公</div>
          <div class="fc">基于小程序的移动办公，响应更快速，服务更及时，有效提升服务效率可打破工作时间、地域限定， 随时随地掌握所有客户动态，及时解答客户疑惑，把握商机。</div>
        </div>
        <div class="rightImg1">
          <img class="pollImg" src="../../assets/images/poll@2x.png" alt="">
          <img :class="{'slither1' : flag}" class="Img001" src="../../assets/images/001@2x.png" alt="">
          <img :class="{'slither2' : flag}" class="Img002" src="../../assets/images/002@2x.png" alt="">
          <img :class="{'slither3' : flag}" class="Img003" src="../../assets/images/003@2x.png" alt="">
          <img :class="{'slither4' : flag}" class="Img004" src="../../assets/images/004@2x.png" alt="">
          <img :class="{'slither5' : flag}" class="Img005" src="../../assets/images/005@2x.png" alt="">
          <div class="sj">
            <img class="sjImg" src="../../assets/images/sj01@2x.png" alt="" srcset="">
            <div class="sjText">销售排行</div>
          </div>
          <div class="userInfo" :class="{'userYd' : flag}">
            <div class="userList">
              <img src="../../assets/images/T_001@2x.png" alt="">
              <div class="con">
                <div class="name">王教授</div>
                <div class="words">欢迎进入我的名片，有什么可以帮...</div>
              </div>
            </div>
            <div class="userList">
              <img src="../../assets/images/T_002@2x.png" alt="">
              <div class="con">
                <div class="name">刘工</div>
                <div class="words">好的，收到</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="refinement">
      <div class="leftImg">
        <img class="refImg" src="../../assets/images/refImg@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg1" src="../../assets/images/ydbg1@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg2" src="../../assets/images/ydbg2@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg3" src="../../assets/images/ydbg3@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg4" src="../../assets/images/ydbg4@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg5" src="../../assets/images/ydbg5@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg6" src="../../assets/images/ydbg6@2x.png" alt="">
        <img :class="{'ref1' : flag1}" class="ydbg7" src="../../assets/images/ydbg7@2x.png" alt="">
      </div>
      <div class="rightContent">
        <div class="title">精细化管理</div>
        <div class="info">
          <img src="../../assets/images/yhhx@2x.png" alt="">
          <div class="text">
            <div class="name">客户画像</div>
            <div class="content">多维度构建用户画像，助力精准营销</div>
          </div>
        </div>
        <div class="info1">
          <img src="../../assets/images/jzsb@2x.png" alt="">
          <div class="text">
            <div class="name">精准用户识别</div>
            <div class="content">精准筛选人群，助力企业针对营销</div>
          </div>
        </div>
      </div>
    </div>
    <BNavigation></BNavigation>
  </div>
</template>

<script>
  import Head from './Head'
  import BNavigation from './bNavigation'
  export default {
    data() {
      return {
        flag: false,
        flag1: false,
        bottleneckList: [{
          title: '品牌信任难',
          content: '缺乏背书，难以打造品牌信任感',
          img: require('../../assets/images/pinp@2x.png'),
        }, {
          title: '行业竞争大',
          content: '经济环境影响行业发展内卷',
          img: require('../../assets/images/hy@2x.png'),
        }, {
          title: '数据收集难',
          content: '沟通过程无监管复盘分析难',
          img: require('../../assets/images/sj@2x.png'),
        }, {
          title: '平台流量贵',
          content: '获客成本高，线索流失大',
          img: require('../../assets/images/ptll@2x.png'),
        }, {
          title: '获客留存难',
          content: '用户画像模糊，留存转化低',
          img: require('../../assets/images/hk@2x.png'),
        }]
      }
    },
    components: {
      Head,
      BNavigation
    },
    mounted() {

      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        console.log('=================', scrollTop)
        if (scrollTop > 1300) {
          this.flag = true
        }
        if (scrollTop > 1900) {
          this.flag1 = true
        }
      },
    }
  }
</script>

<style scoped>
  @media (max-width: 1500px) {
    .bottleneck {
      width: 1440px;
    }
  }

  @media (min-width: 1500px) {
    .bottleneck {
      width: 1640px;
    }
  }

  .banner {
    width: 100%;
    height: 620px;
    background: url('../../assets/images/scrm_bg@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .topT {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    box-sizing: border-box;
  }

  .leftC {
    width: 524px;
  }
    margin-right: 183px;

  .bTitle {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1E232A;
    line-height: 70px;
    letter-spacing: 1px;
  }

  .sTitle {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1E232A;
    line-height: 36px;
    margin: 27px 0 63px;
  }

  .tyBtn {
    width: 154px;
    height: 52px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 26px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rightImg {
    width: 613px;
    height: 479px;
    background: url('../../assets/images/scrm_sc@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .bottleneck {
    height: 800px;
    margin: 0 auto;
    padding-top: 100px;
  }

  .bottleneck>.title,
  .flowPool>.title {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    text-align: center;
  }

  .bottleneck .content {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: flex-start; */
  }

  .bottleneck .content>div {
    width: 33%;
    text-align: center;
  }

  .bottleneck .content>div img {
    margin-top: 40px;
  }

  .it {
    margin-top: 40px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
  }

  .ic {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 30px;
  }

  .flowPool {
    height: 780px;
    margin: 0 auto;
    background: linear-gradient(180deg, #FBFCFC 0%, #FFFFFF 100%);
    padding-top: 100px;
    box-sizing: border-box;
  }

  .flowPool .content {
    margin-top: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flowPool .content .leftinfo {
    width: 560px;
  }

  .flowPool .ft {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    position: relative;
  }

  .flowPool .fc {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 30px;
    margin-top: 70px;

  }

  .flowPool .ft::after {
    content: '';
    width: 96px;
    height: 3px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 2px;
    position: absolute;
    bottom: -30px;
    left: 0px;
  }

  .pollImg {
    width: 706px;
    height: 409px;
  }

  .refinement {
    width: 100%;
    height: 568px;
    background: #F7F9F9;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .refImg {
    width: 591px;
    height: 402px;
  }

  .refinement .rightContent {
    width: 600px;
    margin-left: 100px;
  }

  .refinement .rightContent .title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    position: relative;
  }

  .refinement .rightContent .title::after {
    content: '';
    width: 96px;
    height: 3px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 2px;
    position: absolute;
    bottom: -30px;
    left: 0px;
  }

  .rightContent img {
    width: 42px;
    height: 40px;
  }

  .rightContent .info {
    margin-top: 80px;
    display: flex;
    justify-content: flex-start;
  }

  .rightContent .info .name,
  .rightContent .info1 .name {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 30px;

  }

  .rightContent .info .content,
  .rightContent .info1 .content {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #929EA5;
    line-height: 30px;
  }

  .rightContent .info1 {
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
  }

  .rightContent .info1,
  .rightContent .info {
    display: flex;
    align-items: center;
    text-align: left;
  }

  .text {
    margin-left: 20px;
  }

  .flowPool .rightImg1 {
    width: 706px;
    height: 409px;
    position: relative;
  }

  .Img001,
  .Img002,
  .Img003,
  .Img004,
  .Img005 {
    width: 89px;
    height: 89px;
    position: absolute;
    top: 150px;
    right: 200px;
  }

  .slither1 {
    top: 50px;
    right: 300px;
    animation: 2s fd1;
  }

  @keyframes fd1 {
    0% {
      top: 150px;
      right: 200px;
    }

    100% {
      top: 50px;
      right: 300px;
    }
  }

  .slither2 {
    top: 110px;
    right: 350px;
    animation: 2s fd2;
  }

  @keyframes fd2 {
    0% {
      top: 150px;
      right: 200px;
    }

    100% {
      top: 110px;
      right: 350px;
    }
  }

  .slither3 {
    top: 180px;
    right: 400px;
    animation: 2s fd3;
  }

  @keyframes fd3 {
    0% {
      top: 150px;
      right: 200px;
    }

    100% {
      top: 180px;
      right: 400px;
    }
  }

  .slither4 {
    top: 240px;
    right: 350px;
    animation: 2s fd4;
  }

  @keyframes fd4 {
    0% {
      top: 150px;
      right: 200px;
    }

    100% {
      top: 240px;
      right: 350px;
    }
  }

  .slither5 {
    top: 300px;
    right: 300px;
    animation: 2s fd5;
  }

  @keyframes fd5 {
    0% {
      top: 150px;
      right: 200px;
    }

    100% {
      top: 300px;
      right: 300px;
    }
  }

  .sj {
    width: 130px;
    height: 50px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 4px 9px 2px #F1F7F7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    position: absolute;
    top: 200px;
    right: 200px;
  }

  .sjImg {
    width: 22px;
    height: 19px;
    margin-right: 10px;
  }

  .sjText {
    width: 64px;
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #32454E;
  }

  .userInfo {
    width: 329px;
    height: 174px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 4px 9px 2px #F1F7F7;
    border-radius: 16px;
    padding: 15px 10px;
    position: absolute;
    top: 50px;
    right: -50px;
    overflow: hidden;
  }

  .userYd {
    top: -20px;
    right: -120px;
    animation: 2s fd6;
  }

  @keyframes fd6 {
    0% {
      top: 50px;
      right: -50px;
    }

    100% {
      top: -20px;
      right: -120px;
    }
  }

  .userInfo>div {
    margin: 10px 0;
  }

  .userInfo img {
    width: 72px;
    height: 72px;
  }

  .userInfo .name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #586565;
  }

  .userInfo .words {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A1B2B1;
  }

  .userList,
  .userList1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .userList .con,
  .userList1 .con {
    margin-left: 10px;
  }

  .refinement .leftImg {
    position: relative;
  }

  .ref1 {
    opacity: 1;
    animation: 3s fd7;
  }

  @keyframes fd7 {
    0% {
       opacity: 0;
    }

    100% {
       opacity: 1;
    }
  }

  .ydbg1 {
    width: 97px;
    height: 96px;
    position: absolute;
    top: 30px;
    right: 50px;
  }
  .ydbg2 {
    width: 79px;
    height: 54px;
    position: absolute;
    top: 100px;
    right: 200px;
  }
  .ydbg3 {
    width: 261px;
    height: 77px;
    position: absolute;
    bottom: 130px;
    right: -20px;
  }
  .ydbg4 {
    width: 124px;
    height: 54px;
    position: absolute;
    bottom: 90px;
    right: 180px;
  }
  .ydbg5 {
    width: 261px;
    height: 77px;
    position: absolute;
    top: 80px;
    left: -20px;
  }
  .ydbg6 {
    width: 96px;
    height: 54px;
    position: absolute;
    top: 160px;
    left: 160px;
  }
  .ydbg7 {
    width: 177px;
    height: 127px;
    position: absolute;
    bottom: 40px;
    left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Mkt.vue